import ConfiguracoesAPI from '../api/compras/configuracoes';
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
      fornecedorCompra: "fornecedor/getFornecedor",
      embalaemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster"
    }),
    idFornecedorCompra() {
      return this.fornecedorCompra.id || undefined;
    }
  },
  watch: {
    idFornecedorCompra(novo, antigo){
      this.getConfigFornecedor();

      if (novo && antigo) {
        this.setConfigFornecedor(antigo);
      }
    }
  },
  mounted(){
    this.getConfigTelaCompra();
    this.getConfigFornecedor();
  },
  destroyed() {
    // this.setConfigFornecedor(this.idFornecedorCompra);
    // this.$store.dispatch("fornecedor/setFornecedor", {});
  },
  methods: {
    getConfigTelaCompra(){
      if (!this.configuracoes.carregado) {
        this.$store.dispatch(
          "loading/addRequisicao",
          ConfiguracoesAPI.getConfiguracoesCompras()
            .then((response) => {
              const {token, configs} = response.data;
              localStorage.setItem("token", token);
              configs.carregado = true;
              this.$store.dispatch("configuracoes/setCarrinho", configs);
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    getConfigFornecedor(){
      if (this.idFornecedorCompra >= 0) {
        this.$store.dispatch(
          "loading/addRequisicao",
          ConfiguracoesAPI.getConfigFornecedorCompra(this.idFornecedorCompra)
            .then((response) => {
              const {token, config} = response.data;
              localStorage.setItem("token", token);
              this.$store.dispatch("fornecedor/setConfig", config);
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    setConfigFornecedor(id){
      if (id >= 0) {
        const params = {
          id,
          embalagemMaster: this.embalaemMasterAtivada
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfiguracoesAPI.setConfigFornecedorCompra(params)
            .then((response) => localStorage.token = response.data.token)
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
